export default "assets/images/feuille_3-fa778c35.png";